// Geometria mâinii curente în machetă (v. `../manaCurenta.ts`).
import * as THREE from "three";
import type { ManaCurenta } from "../manaCurenta";

/** Cota de SUS a mâinii curente: pe sticlă, lamele și gardă, cu 1 cm sub muchia
 *  balustradei — la aceeași cotă cu zidul despărțitor dintre două terase, cele
 *  două fețe de sus se băteau (10 și 17 px, 29.09.2026); pe parapetul plin
 *  stă PE creastă, intrată 5 mm în ea (67 px pe colțul logiilor, 0 după). */
export function susulManii(kind: string, zMuchie: number, m: ManaCurenta): number {
  return kind === "solid" ? zMuchie - 0.005 + m.height_m : zMuchie - 0.01;
}

/** Bucata de mână curentă pe segmentul `a`–`b`, cu fața de sus la `zSus`,
 *  mutată cu `retr` spre balcon (pe mijlocul zidului, la parapetul plin) și
 *  prelungită cu `prelA` / `prelB` la capete, ca la un colț al axului cele
 *  două bucăți să se întâlnească, nu să lase o crestătură. */
export function geometriaManii(a: number[], b: number[], n: number[], zSus: number, retr: number,
                               m: ManaCurenta, prelA = 0, prelB = 0): THREE.BufferGeometry | null {
  const ex = b[0] - a[0], ey = b[1] - a[1], l = Math.hypot(ex, ey);
  if (l < 1e-3) return null;
  const ux = ex / l, uy = ey / l;
  const L = l + prelA + prelB;
  const cx = a[0] + ux * (l / 2 + (prelB - prelA) / 2) - n[0] * retr;
  const cy = a[1] + uy * (l / 2 + (prelB - prelA) / 2) - n[1] * retr;
  let g: THREE.BufferGeometry;
  if (m.profile === "round") {
    // ȚEAVA: cilindrul three stă pe y; culcat pe x, apoi rotit pe ax
    g = new THREE.CylinderGeometry(m.width_m / 2, m.width_m / 2, L, 16, 1, false);
    g.applyMatrix4(new THREE.Matrix4().makeRotationZ(-Math.PI / 2));
  } else {
    g = new THREE.BoxGeometry(L, m.width_m, m.height_m);
  }
  g.applyMatrix4(new THREE.Matrix4().makeRotationZ(Math.atan2(ey, ex)));
  g.translate(cx, cy, zSus - m.height_m / 2);
  return g;
}
